import React, { useState } from "react";

import LandingHeader from "../common/LandingHeader";
import LandingFooter from "../common/LandingFooter";

import './pricing.css';

const PricingPage = () => {
  return (
    <div className="landing overflow-hidden">
      <section className="section heroSec pt-4">

        <LandingHeader />

        <div className="container">
          <div className="hero-content">
            <div className="pricing-hero">
              <h1 className="mb-0 fw700 ff3">
                Pricing Plan
              </h1>
              <div className="pricing-hero__sub-row">
                <p className="mb-0 fz20 sub-text">
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since took a galley.
                </p>

                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="ff2 nav-link active" id="pills-yearly-tab" data-bs-toggle="pill" data-bs-target="#pills-yearly" type="button" role="tab" aria-controls="pills-yearly" aria-selected="true">Yearly</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="ff2 nav-link" id="pills-monthly-tab" data-bs-toggle="pill" data-bs-target="#pills-monthly" type="button" role="tab" aria-controls="pills-monthly" aria-selected="false">Monthly</button>
                  </li>
                </ul>
              </div>
              <div className="bdrs40 pricing-hero__cards">
                <div class="tab-content" id="pills-tabContent">
                  <div class="tab-pane fade show active" id="pills-yearly" role="tabpanel" aria-labelledby="pills-yearly-tab" tabindex="0">
                    <ul className="mb-0 list-inline p-cards">
                      <li>
                        <div className="ff2 bdrs40 p-cards__single">
                          <div className="ts03 fw500 price">
                            <div className=" fw700 num">$300</div>
                            /year
                          </div>
                          <div className="fw500 ts03 plan-name">
                            Basic
                          </div>
                          <div className="fw500 ts03 plan-desc">
                            Automation plus enterprise-grade features.
                          </div>

                          <ul className="list-unstyled ts03 features fz20">
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                          </ul>

                          <button type="button" className="btn btn-solid" >Choose Plan</button>
                        </div>
                      </li>
                      <li>
                        <div className="ff2 bdrs40 p-cards__single">
                          <div className="ts03 fw500 price">
                            <div className=" fw700 num">$440</div>
                            /year
                          </div>
                          <div className="fw500 ts03 plan-name">
                            Standard
                          </div>
                          <div className="fw500 ts03 plan-desc">
                            Automation plus enterprise-grade features.
                          </div>

                          <ul className="list-unstyled ts03 features fz20">
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                          </ul>

                          <button type="button" className="btn btn-solid" >Choose Plan</button>
                        </div>
                      </li>
                      <li>
                        <div className="ff2 bdrs40 p-cards__single">
                          <div className="ts03 fw500 price">
                            <div className=" fw700 num">$620</div>
                            /year
                          </div>
                          <div className="fw500 ts03 plan-name">
                            Premium
                          </div>
                          <div className="fw500 ts03 plan-desc">
                            Automation plus enterprise-grade features.
                          </div>

                          <ul className="list-unstyled ts03 features fz20">
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                          </ul>

                          <button type="button" className="btn btn-solid" >Choose Plan</button>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="tab-pane fade" id="pills-monthly" role="tabpanel" aria-labelledby="pills-monthly-tab" tabindex="0">
                    <ul className="mb-0 list-inline p-cards">
                      <li>
                        <div className="ff2 bdrs40 p-cards__single">
                          <div className="ts03 fw500 price">
                            <div className=" fw700 num">$30</div>
                            /month
                          </div>
                          <div className="fw500 ts03 plan-name">
                            Basic
                          </div>
                          <div className="fw500 ts03 plan-desc">
                            Automation plus enterprise-grade features.
                          </div>

                          <ul className="list-unstyled ts03 features fz20">
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                          </ul>

                          <button type="button" className="btn btn-solid" >Choose Plan</button>
                        </div>
                      </li>
                      <li>
                        <div className="ff2 bdrs40 p-cards__single">
                          <div className="ts03 fw500 price">
                            <div className=" fw700 num">$44</div>
                            /month
                          </div>
                          <div className="fw500 ts03 plan-name">
                            Standard
                          </div>
                          <div className="fw500 ts03 plan-desc">
                            Automation plus enterprise-grade features.
                          </div>

                          <ul className="list-unstyled ts03 features fz20">
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                          </ul>

                          <button type="button" className="btn btn-solid" >Choose Plan</button>
                        </div>
                      </li>
                      <li>
                        <div className="ff2 bdrs40 p-cards__single">
                          <div className="ts03 fw500 price">
                            <div className=" fw700 num">$62</div>
                            /month
                          </div>
                          <div className="fw500 ts03 plan-name">
                            Premium
                          </div>
                          <div className="fw500 ts03 plan-desc">
                            Automation plus enterprise-grade features.
                          </div>

                          <ul className="list-unstyled ts03 features fz20">
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                            <li>
                              Lorem Ipsum is simply dummy
                            </li>
                          </ul>

                          <button type="button" className="btn btn-solid" >Choose Plan</button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ff2 section section-faq">
        <div className="container">
          <h1 className="text-center fw700 ff3">
            Frequently Asked Questions
          </h1>

          <p className="text-center mb-0 fz20">
            Any question or remarks? Just write us a message!
          </p>

          <div className="row QnA">
            <div class="accordion accordion-flush" id="accordionFaq">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="fz24 fw700 accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    There are many variations of passages of Lorem 1
                  </button>
                </h2>
                <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFaq">
                  <div class="fz24 fw500 accordion-body">
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="fz24 fw700 accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                    There are many variations of passages of Lorem 2
                  </button>
                </h2>
                <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFaq">
                  <div class="fz24 fw500 accordion-body">
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="fz24 fw700 accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                    There are many variations of passages of Lorem 3
                  </button>
                </h2>
                <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFaq">
                  <div class="fz24 fw500 accordion-body">
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <LandingFooter />
    </div>
  );
};

export default PricingPage;